import { useSelector } from 'react-redux';

import { getLanguage } from '../../../../../state/login';

export const useLanguage = () => useSelector(getLanguage);
